import { Outlet, useParams } from 'react-router-dom';

import {
  ClientScopeProvider,
  ScopeLoading,
  useAdvisorClient,
} from '@/context/ClientScopeProvider';

export default function AdvisorClientScope() {
  const { id } = useParams<{ id: string }>();
  const { data: client, isLoading } = useAdvisorClient(id);

  if (isLoading || !client) return <ScopeLoading />;

  return (
    <ClientScopeProvider
      value={{
        client,
        clientId: client.id,
        orgId: client.customer_organization_id,
        perspective: 'advisor',
        basePath: `/advisor/clients/${client.id}`,
        processPath: (specId) => `/advisor/customer-processes/${specId}`,
      }}
    >
      <Outlet />
    </ClientScopeProvider>
  );
}
